import { render, staticRenderFns } from "./airplaneModel.vue?vue&type=template&id=5971a8fc&scoped=true&"
import script from "./airplaneModel.vue?vue&type=script&lang=js&"
export * from "./airplaneModel.vue?vue&type=script&lang=js&"
import style0 from "./airplaneModel.vue?vue&type=style&index=0&id=5971a8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971a8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5971a8fc')) {
      api.createRecord('5971a8fc', component.options)
    } else {
      api.reload('5971a8fc', component.options)
    }
    module.hot.accept("./airplaneModel.vue?vue&type=template&id=5971a8fc&scoped=true&", function () {
      api.rerender('5971a8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/airplaneModel.vue"
export default component.exports